import React from 'react';

export default function Navbar() {
    return (
        <div>
            <div className='banner'>
                <a href="/">
                    <div className='py-10 flex items-center justify-center font-serif text-2xl text-white'>
                        <img src="/logo_light.png" alt="tax debt united" className='h-12 mr-2' /> Tax Debt United
                    </div>
                </a>
            </div>
        </div>
    );
}
